import { useEffect } from 'react';
import { useStore } from 'hooks';
import { useTour } from '../use-tour';
import { toast } from 'components/ui';
import { TOUR_REGISTRY } from '../tour.registry';

export const useRequestPageTour = (enabled?: boolean) => {
  const { startTour, persistence } = useTour();
  const { onboardings, user } = useStore();

  useEffect(() => {
    if (persistence.hasSeen('request_page', user.id) || !enabled) {
      return;
    }

    const tour = TOUR_REGISTRY['request_page'];

    const id = toast({
      title: 'Работа с заявкой теперь на одной странице!',
      description:
        'Все ключевые действия — просмотр, редактирование и управление — собраны в одном месте. Больше не нужно переключаться между экранами.',
      actions: {
        acceptLabel: 'Показать, как это работает',
        cancelLabel: 'Пропустить',
        onAccept: () => startTour('request_page'),
        onCancel: () =>
          onboardings.patchOnboardingInfo(
            {
              block: 'request_page',
              viewed: true,
              version: tour.version,
            },
            user.id
          ),
      },
    });

    return () => {
      toast.dismiss(id);
    };
  }, [enabled]);
};
